export default __webpack_public_path__ + "static/media/apple_help_1.c77dbac8.jpg";